import { createEnum } from './enum.js'

export default createEnum("Upper", "Lower", "Both")
